import React from "react";
import TextField from "@material-ui/core/TextField";
import {DesktopDateRangePicker, LocalizationProvider, MobileDateRangePicker} from "@material-ui/pickers";
import Box from "@material-ui/core/Box";
import {MuiThemeProvider} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ruLocale from "date-fns/locale/ru";
import format from "date-fns/format";
import DateFnsUtils from "@date-io/date-fns";
import {materialTheme} from "./styles";
import {useField, useFormikContext} from "formik";


const initProps = {
    mask: "__.__.____",
    PopperProps: {
        placement: "bottom-start",
    },
    okText: "Применить",
    cancelText: "Закрыть",
    startText: 'От',
    endText: 'До',
    toolbarTitle: 'Даты от/до',
};



const BasicDateRangePicker = (props) => {
    const finalProps = {...initProps, ...props};
    const matches = useMediaQuery('(max-width:800px)');

    const {setFieldValue} = useFormikContext();
    const [field] = useField(props);
    const {mobilePicker} = props;

    return (
        <MuiThemeProvider theme={materialTheme}>
            <LocalizationProvider dateAdapter={DateFnsUtils} utils={DateFnsUtils} locale={ruLocale}>
                {matches || mobilePicker
                    ? <MobileDateRangePicker
                        {...finalProps}
                        {...field}

                        onChange={(date) => {
                            setFieldValue(field.name, date, false);
                            field.value = date;
                            if (finalProps.hasOwnProperty('onCustomChange')) {
                                finalProps.onCustomChange(field);
                            }
                        }}

                        renderInput={(startProps, endProps) => (
                            <Box className={"d-flex justify-content-between"}>
                                <TextField size={"small"} color="secondary" className={"me-1 mb-1 w-100"}
                                           label={finalProps.startText}
                                           error={Boolean(finalProps.helperText)}
                                           helperText={finalProps.helperText}
                                           variant="outlined" ref={startProps.inputRef} {...startProps.inputProps}
                                           placeholder={" "}/>

                                <TextField size={"small"} color="secondary" className={"ms-1 mb-1 w-100"}
                                           label={finalProps.endText}
                                           error={Boolean(finalProps.helperText)}
                                           helperText={finalProps.helperText}
                                           variant="outlined" ref={endProps.inputRef} {...endProps.inputProps}
                                           placeholder={" "}/>
                            </Box>
                        )}
                    />
                    : <DesktopDateRangePicker
                        {...finalProps}
                        {...field}

                        onChange={(date) => {
                            setFieldValue(field.name, date, false);
                            field.value = date;
                            if (finalProps.hasOwnProperty('onCustomChange')) {
                                finalProps.onCustomChange(field);
                            }
                        }}
                        renderInput={(startProps, endProps) => (

                            <Box className={"d-flex justify-content-between"}>
                                <TextField size={"small"} color="secondary" className={"me-1 mb-1 w-100"}
                                           label={finalProps.startText}
                                           error={Boolean(finalProps.helperText)}
                                           helperText={finalProps.helperText}
                                           variant="outlined" ref={startProps.inputRef}  {...startProps.inputProps}
                                           placeholder={" "}/>

                                <TextField size={"small"} color="secondary" className={"ms-1 mb-1 w-100"}
                                           label={finalProps.endText}
                                           error={Boolean(finalProps.helperText)}
                                           helperText={finalProps.helperText}
                                           variant="outlined" ref={endProps.inputRef} {...endProps.inputProps}
                                           placeholder={" "}/>
                            </Box>
                        )}
                    />
                }
            </LocalizationProvider>

        </MuiThemeProvider>


    );
}

export default BasicDateRangePicker